import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux/store'
import { useAppDispatch } from '../../redux/hooks'
import { setActiveSport } from '../../redux/slices/sportsSlice'
import { useTranslation } from '../../hooks/useTranslation'

const SportCarousel = () => {
	const dispatch = useAppDispatch()
	const sports = useSelector((state: RootState) => state.sports.sports)
	const activeSport = useSelector((state: RootState) => state.sports.activeSport)

	const { selectedLanguage } = useTranslation(false)

	const scrollContainerRef = useRef<HTMLDivElement>(null)
	const [atStart, setAtStart] = useState(true)
	const [atEnd, setAtEnd] = useState(false)

	const handleScroll = () => {
		if (!scrollContainerRef.current) return
		const { scrollLeft, scrollWidth, clientWidth } = scrollContainerRef.current
		setAtStart(scrollLeft <= 0)
		setAtEnd(scrollLeft + clientWidth >= scrollWidth)
	}

	const handleNext = () => {
		if (scrollContainerRef.current) {
			scrollContainerRef.current.scrollBy({ left: 86, behavior: 'smooth' })
		}
	}

	const handlePrev = () => {
		if (scrollContainerRef.current) {
			scrollContainerRef.current.scrollBy({ left: -86, behavior: 'smooth' })
		}
	}

	useEffect(() => {
		handleScroll()
	}, [])

	return (
		<div className="sport-carousel" style={{ position: 'relative' }}>
			{!atStart && <div className="arrow-left" onClick={handlePrev} />}
			<div className="sport-carousel__scroll-container" ref={scrollContainerRef} onScroll={handleScroll}>
				{sports.map((sport, index) => (
					<div
						key={index}
						className={`sport-carousel__item ${sport.sport_id === activeSport?.sport_id ? 'active' : ''}`}
						style={{ flex: '0 0 auto' }}
						onClick={() => dispatch(setActiveSport(sport))}
					>
						<div className="sport-carousel__item-image" style={{ backgroundImage: `url(${sport.sport_icon})` }} />
						<div className="sport-carousel__item-name">{selectedLanguage === 'en' ? sport.name : sport.pt_name}</div>
					</div>
				))}
			</div>
			{!atEnd && <div className="arrow-right" onClick={handleNext} />}
		</div>
	)
}

export default SportCarousel
